// UserHashtagCard.js
'use strict';
import { connect } from 'react-redux';

import UserHashtagCard from '../component/UserHashtagCard.jsx';
import getUserData from '../selector/getUserData.js';
import { HASHTAG_FEED_USER, USER_HASHTAG } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const mapStateToProps = (state, { userId }) => {
  return {
    hashtagFeedUser: getRemoteConfigData(state, HASHTAG_FEED_USER),
    shouldShowUserHashtags: getRemoteConfigData(state, USER_HASHTAG) === '1',
    username: getUserData(state, userId, 'username'),
    hashtags: getUserData(state, userId, 'hashtags'),
  };
};

export default connect(mapStateToProps, null)(UserHashtagCard);
